export interface ITenantConfiguration {
    code: string;
    orderIndex: number;
    displayName: string;
}

export const tenantConfiguration: ITenantConfiguration[] = [
    {
        code: "EHM",
        orderIndex: 1,
        displayName: "EHM",
    },
    {
        code: "EHZ",
        orderIndex: 2,
        displayName: "EHŻ",
    },
];

export interface IReportEntityType {
    code: string;
    orderIndex: number;
    displayName: string;
}

export const reportEntityTypes: IReportEntityType[] = [
    {
        code: "RETAIL",
        orderIndex: 1,
        displayName: "Detal",
    },
    {
        code: "CORPO",
        orderIndex: 2,
        displayName: "Korpo",
    },
];

export const goalCodes = {
    apeGz: "APE_GZ",
    lapse: "POZIOM_LAPSE",
};

export const unsummarizableGoals = new Set<string>([goalCodes.apeGz, goalCodes.lapse]);
